import Bowser from "bowser";
import log from "loglevel";

const browserInfo = Bowser.parse(navigator.userAgent);
log.info(JSON.stringify(browserInfo), "current browser info");

export default browserInfo;
